document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.u-nothing-video-wrapper').forEach(function (box) {
    const video = box.querySelector('video');
    const playBtn = box.querySelector('.play-pause');
    const muteBtn = box.querySelector('.mute-unmute');
    const fullBtn = box.querySelector('.fullscreen-btn');

    video.muted = true;
    video.pause();

    playBtn.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playBtn.innerHTML = `
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Pause" style="width:var(--rsw, 100%);height:auto;max-height:100%" class="r-tboce0" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"></path></svg>`;
      } else {
        video.pause();
        playBtn.innerHTML = `
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Play" class="r-kky9gi" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%); height: auto; max-height: 100%;"><path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"></path></svg>`;
      }
    });

    muteBtn.addEventListener('click', function () {
      video.muted = !video.muted;

      if (video.muted) {
        muteBtn.innerHTML = `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Unmute" class="r-28cf31" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%); height: auto; max-height: 100%;"><path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"></path></svg>`; // muted icon
      } else {
        muteBtn.innerHTML = `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Mute" class="r-1wofikj" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%); height: auto; max-height: 100%;"><path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"></path><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"></path><path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"></path></svg>`; // unmuted icon
      }
    });
    fullBtn.addEventListener('click', function () {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    });

    document.addEventListener('fullscreenchange', function () {
      const isFullscreen = document.fullscreenElement === video;

      if (isFullscreen) {
        video.style.objectFit = 'contain';
        box.querySelector('.u-nothing-video-controls').style.display = 'flex';
      } else {
        video.style.objectFit = 'cover';
        box.querySelector('.u-nothing-video-controls').style.display = 'flex';
      }
    });
  });
});


